import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { CardText, CardSubtitle, CardTitle, CardImg, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';
import ReactToPrint from "react-to-print";
import PropTypes from "prop-types";
import LOGO from "../../assets/images/xelapan-logo-2019.png"
//material react
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    root: {
        maxWidth: 500,
    },
    media: {
        height: 250,
    }
});

export class ComponentToPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            classes: useStyles
        }
    }
    componentDidMount() {
       
    }

    render() {
        const {
            classes
        } = this.state;
        return (
            <React.Fragment>
                <div className="containerbg-info clearfix">
                    <Container>
                        <Row className="align-items-center justify-content-center">
                            <Col lg={5}>
                                <div className="text-center mb-5 d-block auth-logo">
                                    <Row>
                                        <Col lg={4}>
                                            <img src={LOGO} alt="" width="25%" className="logo logo-dark" />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={3}>
                                <Label htmlFor="" className="form-label">
                                    Tarjeta de Responsabilidad #{this.props.registro.id}
                                </Label>
                            </Col>
                            <Col lg={3}>
                                <Label htmlFor="" className="form-label">
                                    Asignad@: {this.props.registro.colaborador.label}
                                </Label>
                            </Col>
                            <Col lg={3}>
                                <Label htmlFor="" className="form-label">
                                    Ubicacion: {this.props.registro.departamento.ubicacion}
                                </Label>
                            </Col>
                            <Col lg={3}>
                                <Label htmlFor="" className="form-label">
                                    Departamento: {this.props.registro.departamento.area}
                                </Label>
                            </Col>
                        </Row>
                        <Row className="align-items-center justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Table borderless>
                                    <thead>
                                        <tr>
                                            <th>Serie</th>
                                            <th>Articulo</th>
                                            <th>Descripcion</th>
                                            <th>Marca</th>
                                            <th>Costo</th>
                                            <th>Unidades</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{this.props.registro.articulo.serie}</td>
                                            <td>{this.props.registro.articulo.nombre}</td>
                                            <td>{this.props.registro.articulo.descripcion}</td>
                                            <td>{this.props.registro.articulo.marca}</td>
                                            <td>{this.props.registro.articulo.costo}</td>
                                            <td>{this.props.registro.cantidad}</td>
                                            <td>{this.props.registro.monto}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <div className="mt-5 text-center text-muted">
                                    <p>© {new Date().getFullYear()} Xelapan</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default class printAsignado extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
            }
        };

    }

    componentDidMount() {

    }

    render() {

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col>
                                <ReactToPrint
                                    trigger={() => <MDBBtn className="waves-effect" color="success" onClick={() => { this.props.history.replace('/articuloAsignar') }}>
                                        <MDBIcon icon="fas fa-print" />{' '}
                                        Imprimir
                                    </MDBBtn>
                                    }
                                    content={() => this.componentRef}
                                />
                            </Col>
                        </Row>
                        <p />
                        <Row>
                            <Col lg={12}>
                                <ComponentToPrint ref={el => (this.componentRef = el)} registro={this.state.registro} />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={3}>
                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/tarjeta') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}